import axios from "axios";
import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import view from "../../images/view.png";
import {
    COUNTRY_URL,
    EVENT_ASSOCIATE_URL,
    SITE_DETAILS_URL,
    SITE_MANAGEMENT_DETAILS
} from '../ApiDetails.js';
import Header from "../HeaderAdmin";
import Navbar from "../Navbar.js";
import "./SiteManagement.css";

function SiteManagement() {
    const [sites, setSites] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();

    const [segment, setSegment] = useState([]);
    const [countryFilters, setCountryFilters] = useState([]);
    const [unitFilters, setUnitFilters] = useState([]);
    const [reportsFilter, setReportsFilter] = useState({
        selectedSegment: "All",
        selectedCountry: "All",
        selectedSite: "All",
        selectedDropdownValue: "All",
    });

    useEffect(() => {
        fetchSites();
    }, []);

    useEffect(() => {
        calculateTotalPages(sites);
    }, [sites]);

    const fetchSites = async () => {
        try {
            const response = await axios.get(SITE_MANAGEMENT_DETAILS);
            const data = response.data;
            setSites(data);
            calculateTotalPages(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const calculateTotalPages = (data) => {
        const total = Math.ceil(data.length / pageSize);
        setTotalPages(total);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const SeeSiteDetails = (site) => {
        if (site.id) {
            navigate("/siteDetails", { state: { site, siteId: site.id } });
        } else {
            console.error("Site ID is undefined");
        }
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPageNumbersToShow = 5;

        let startPage = Math.max(
            1,
            currentPage - Math.floor(maxPageNumbersToShow / 2)
        );
        let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage + 1 < maxPageNumbersToShow) {
            startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    const currentPageData = sites.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [segmentResponse, countryResponse, unitResponse] =
                    await Promise.all([
                        axios.get(EVENT_ASSOCIATE_URL),
                        axios.get(COUNTRY_URL),
                        axios.get(SITE_DETAILS_URL),
                    ]);
                setSegment(segmentResponse.data);
                setCountryFilters(countryResponse.data);

                const uniqueValues = new Set();
                unitResponse.data.forEach((site) => {
                    uniqueValues.add(`${site.site_code} - ${site.unit}`);
                });

                setUnitFilters(Array.from(uniqueValues));
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    const handleApplyFilterClick = async () => {
        try {
            const { selectedSegment, selectedCountry, selectedSite } = reportsFilter;

            // Initialize URLSearchParams object
            const filterParams = new URLSearchParams();

            // Append parameters only if they are not "All" or empty
            if (selectedSegment && selectedSegment !== "All") {
                filterParams.append("segment", selectedSegment);
            }

            if (selectedCountry && selectedCountry !== "All") {
                filterParams.append("country", selectedCountry);
            }

            if (selectedSite && selectedSite !== "All") {
                filterParams.append("siteCode", selectedSite.split(" ")[0]);
            }

            // Construct the full API URL with or without query parameters
            const parameters = filterParams.toString() ? `${filterParams.toString()}` : "";
            const response = await axios.get(`${SITE_MANAGEMENT_DETAILS}?${parameters}`);
            const data = response.data;
            setSites(data);
            calculateTotalPages(data);
        } catch (error) {
            console.error("Error fetching filtered event details:", error);
        }
    };

    const handleClearAllFilters = () => {
        setReportsFilter({
            selectedSegment: "All",
            selectedCountry: "All",
            selectedSite: "All",
            selectedDropdownValue: "All"
        });
        fetchSites();
    };

    return (
        <>
            <Header />
            <div>
                <Navbar />
                <div className="container-fluid">
                    <div className="row m-4">
                        <div className="m-2 bg-light rounded p-3">
                            <div className="large-custom-font">Site Management</div>
                        </div>
                        <div className="m-2 bg-light rounded p-3">
                            <div className="cards">
                                <div className="row">
                                    <div className="d-flex bd-highlight">
                                        <div className="p-2 flex-fill bd-highlight">
                                            <h4 className="reportTitle mt-4">FILTERS</h4>
                                        </div>
                                        <div className="p-4 col-10 d-flex align-content-start flex-wrap">
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="input-group mb-0">
                                                            <label
                                                                className="input-group-text input-group-text-custom"
                                                                htmlFor="country"
                                                            >
                                                                COUNTRY
                                                            </label>
                                                            <select
                                                                className="form-control-custom rounded form-select"
                                                                aria-label="Country"
                                                                id="country"
                                                                value={reportsFilter.selectedCountry} // Bind value to state
                                                                onChange={(e) => {
                                                                    setReportsFilter({
                                                                        ...reportsFilter,
                                                                        selectedCountry: e.target.value,
                                                                    });
                                                                }}
                                                            >
                                                                <option value="All">All</option>
                                                                {countryFilters.length > 0 &&
                                                                    countryFilters.map((countryName, index) => (
                                                                        <option key={index} value={countryName}>
                                                                            {countryName}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="input-group mb-0">
                                                            <label
                                                                className="input-group-text input-group-text-custom"
                                                                htmlFor="segment"
                                                            >
                                                                SEGMENT
                                                            </label>
                                                            <select
                                                                className="form-control-custom rounded form-select"
                                                                aria-label="Segment"
                                                                id="segment"
                                                                value={reportsFilter.selectedSegment}
                                                                onChange={(e) => {
                                                                    setReportsFilter({
                                                                        ...reportsFilter,
                                                                        selectedSegment: e.target.value,
                                                                    });
                                                                }}
                                                            >
                                                                <option value="All">All</option>
                                                                {segment.length > 0 &&
                                                                    segment.map((segmentName, index) => (
                                                                        <option key={index} value={segmentName}>
                                                                            {segmentName}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="input-group mb-0">
                                                            <label
                                                                className="input-group-text input-group-text-custom"
                                                                htmlFor="sites"
                                                            >
                                                                SITE
                                                            </label>
                                                            <select
                                                                className="form-control-custom rounded form-select"
                                                                aria-label="sites"
                                                                id="sites"
                                                                value={reportsFilter.selectedDropdownValue} // Use `selectedDropdownValue` for display
                                                                onChange={(e) => {
                                                                    const selectedValue = e.target.value;
                                                                    const siteCode = selectedValue.split(" - ")[0]; // Extract site code

                                                                    setReportsFilter({
                                                                        ...reportsFilter,
                                                                        selectedSite: siteCode,
                                                                        selectedDropdownValue: selectedValue
                                                                    });
                                                                }}
                                                            >
                                                                <option value="All">All</option>
                                                                {unitFilters.length > 0 &&
                                                                    unitFilters.map((value, index) => (
                                                                        <option key={index} value={value}>
                                                                            {value}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-1 text-end">
                                            <button
                                                className="btn-primary-custom p-1 mt-4"
                                                onClick={handleApplyFilterClick}
                                            >
                                                Apply Filters
                                            </button>
                                            <button
                                                className="btn-secondary-custom"
                                                onClick={handleClearAllFilters}
                                            >
                                                {" "}
                                                Clear All{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="m-2 bg-light rounded p-0">
                            <div className="container-fluid listitemsadmin listitems p-2">
                                <div className="table-responsive">
                                    <div className="table">
                                        <div className="row custom-table-font-header bg-light p-3 rounded m-3">
                                            <div className="col-12 col-md-2">Site Code</div>
                                            <div className="col-12 col-md-2">Unit</div>
                                            <div className="col-12 col-md-2">Segment</div>
                                            <div className="col-12 col-md-2">Site Opening</div>
                                            <div className="col-12 col-md-2">Location</div>
                                            <div className="col-12 col-md-2">Visits</div>
                                        </div>
                                        {currentPageData.length > 0 ? (
                                            currentPageData.map((site, index) => (
                                                <div
                                                    className="row custom-table-tr bg-light p-2 rounded m-3 align-items-center"
                                                    key={index}>
                                                    <div className="col-12 col-md-2">
                                                        {site.site_code}
                                                    </div>
                                                    <div className="col-12 col-md-2">
                                                        {site.unit}
                                                    </div>
                                                    <div className="col-12 col-md-2">
                                                        {site.business_unit ? `${site.business_unit}` : ""}
                                                    </div>
                                                    <div className="col-12 col-md-2">
                                                        {site.move_in_date ? new Date(site.move_in_date).toLocaleDateString('en-US', {timeZone: 'UTC'}) : ""}
                                                    </div>
                                                    <div className="col-12 col-md-2">{site.location}</div>
                                                    <div className="col-12 col-md-1">
                                                        {site.eventCount}
                                                    </div>

                                                    <div className="col-12 col-md-1 text-end">
                                                        <button
                                                            className="btn btn-icon"
                                                            onClick={() => SeeSiteDetails(site)}
                                                        >
                                                            <img
                                                                src={view}
                                                                alt="Edit"
                                                                width={24}
                                                                height={24}
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="row bg-light p-2 rounded m-3 align-items-center">
                                                <div className="col-12 text-center">No Sites Found</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="paging align-items-center">
                                <span className="centered-text">
                                    {(currentPage - 1) * pageSize + 1}-
                                    {Math.min(currentPage * pageSize, sites.length)} OF{" "}
                                    {sites.length} ELEMENTS
                                </span>
                                <nav>
                                    <ul
                                        className="pagination justify-content-end"
                                        style={{ marginBottom: "17px" }}
                                    >
                                        <li
                                            className={`page-item ${currentPage === 1 ? "disabled" : ""
                                                }`}
                                        >
                                            <span
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                style={{ fontSize: "12px", padding: "4px 8px", cursor: "pointer" }}
                                            >
                                                &lt;
                                            </span>
                                        </li>
                                        {getPageNumbers().map((number) => (
                                            <li
                                                key={number}
                                                className={`page-item ${currentPage === number ? "active" : ""
                                                    }`}
                                            >
                                                <span
                                                    className="page-link"
                                                    onClick={() => handlePageChange(number)}
                                                    style={{ fontSize: "12px", padding: "4px 8px", cursor: "pointer" }}
                                                >
                                                    {number}
                                                </span>
                                            </li>
                                        ))}
                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <span
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                style={{ fontSize: "12px", padding: "4px 8px", cursor: "pointer" }}
                                            >
                                                &gt;
                                            </span>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SiteManagement;
